import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

export type PlatformSettings = {
  defaultPlatformFeePercent: number;

  platformName: string;
  platformAdminEmail: string;
  supportEmail: string;
  frontendUrl: string;

  publicSignupEnabled: boolean;
  marketplaceEnabled: boolean;
  demoRequestsEnabled: boolean;

  totalTenants: number;
  totalLocations: number;
  totalUnits: number;
};

export type UpdatePlatformSettings = {
  defaultPlatformFeePercent?: number;
  supportEmail?: string;
  publicSignupEnabled: boolean;
  marketplaceEnabled: boolean;
  demoRequestsEnabled: boolean;
};

export function usePlatformSettings() {
  return useQuery({
    queryKey: ['platform-settings'],
    queryFn: () => apiClient<PlatformSettings>('/platform/settings'),
  });
}

export function useUpdatePlatformSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdatePlatformSettings) =>
      apiClient<PlatformSettings>('/platform/settings', {
        method: 'PUT',
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['platform-settings'] });
      // The default fee flows into tenant onboarding and the detail
      // page's "default vs custom" tagging — invalidate those so a
      // just-saved default takes effect across the admin.
      qc.invalidateQueries({ queryKey: ['platform-tenants'] });
      qc.invalidateQueries({ queryKey: ['platform-tenant-detail'] });
    },
  });
}
